<template>
  <div class="bsFundsDetail">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.contactName" placeholder="商户名称" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.phone" placeholder="商户电话" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-date-picker v-model="time" type="daterange" :append-to-body="false" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" >
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllBsFund">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
          <el-button style="background-color:#FF4000" icon="el-icon-bottom" @click="bsCapitalDetailExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="742" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="联系人名称" width="200" align="center" prop="name"></el-table-column>
        <el-table-column label="商户类型" width="100" align="center" prop="type"></el-table-column>
        <el-table-column label="联系方式" width="150" align="center" prop="phone"></el-table-column>
        <el-table-column label="所属代理" width="180" align="center" prop="csName"></el-table-column>
        <el-table-column label="所属BD" width="180" align="center" prop="bdName"></el-table-column>
        <el-table-column label="已出帐金额" align="center" width="150" prop="outAccount"></el-table-column>
        <el-table-column label="未出账金额" align="center" width="150" prop="outStanding"></el-table-column>
        <el-table-column label="已提现金额" align="center" width="150" prop="withdrawMoney"></el-table-column>
        <el-table-column label="可提现余额" align="center" width="150" prop="withdrawAble"></el-table-column>
        <el-table-column label="体现中金额" align="center" width="150" prop="withdrawingMoney"></el-table-column>
        <el-table-column label="提现冻结" align="center" width="150" prop="withdrawForzenMoney"></el-table-column>
        <el-table-column label="冻结余额" align="center" width="150" prop="freezeMoney"></el-table-column>
        <el-table-column label="累计手续费" align="center" width="150" prop="serviceMoney"></el-table-column>
        <el-table-column label="累计税费" align="center" width="150" prop="rateMoney"></el-table-column>
        <el-table-column label="账户状态" align="center" width="150">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.state === '0'">正常</el-tag>
            <el-tag type="warning" v-if="scope.row.state === '1'">冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提现记录" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" plain size="small" @click="bsWithdraw(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="310" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" plain v-if="scope.row.state === '0'" size="small" style="width: 80px;margin:0" @click="accountOperation(scope.row)">冻结账户</el-button>
            <el-button type="warning" plain v-if="scope.row.state === '1'" size="small" style="width: 80px;margin:0" @click="accountOperation(scope.row)">解冻账户</el-button>
            <el-button type="warning" plain size="small" style="width: 80px;margin:0" @click="showFrozenMoneyDialog(scope.row)">冻结余额</el-button>
            <el-button type="warning" plain size="small" style="width: 80px;margin:0" @click="unFrozen(scope.row.id)">解冻余额</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <bs-withdraw v-if="bsWithdrawDialog" ref="bsWithdraw"></bs-withdraw>
    <el-dialog :visible.sync="frozenMoneyDialog" width="20%" top="25vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false :close-on-press-escape = false :show-close = false @close="closeDialog"> 
      <el-card>
        <el-form ref="form" :model="request" label-position="right">
          <el-row>
            <el-col :span="24">
              <el-form-item><span>可提现金额：{{canUserMoney}}</span></el-form-item>
            </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                <el-form-item><span>&nbsp;&nbsp;&nbsp;&nbsp;冻结金额：</span><el-input v-model="frozenMoney" placeholder="冻结金额" style="width:150px" clearable></el-input></el-form-item>
              </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item><span>&nbsp;&nbsp;&nbsp;&nbsp;冻结原因：</span><el-input type="textarea" :rows="2" placeholder="冻结原因" v-model="reason" style="width:150px"></el-input></el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button style="background-color:#A9F5F2;margin: 0" @click="frozenMoneyDialog = false" size="small">取消</el-button>
        <el-button style="background-color:#A9F5A9" @click="frozenMoneyOperation" size="small">确定</el-button>
      </span>
    </el-dialog>
    <un-frozen v-if="unFrozenDialog" ref="unFrozen" @unfrozen-succeed="unFrozenSucceed"></un-frozen>
  </div>
  
</template>

<script>
import {bcCapitalDetail, operationAccount, frozenBalance, bsCapitalDetailExport} from "../../../api/accountFunds/bsfundsdetail";
import { formatDate } from "../../../utils/date";
import {GLOBAL_URL} from '../../../config/config.js'
import UnFrozen from './bsunfrozenmoney.vue'
import BsWithdraw from './bsWithdraws.vue'

export default {
  name: "BsFundsDetail",
  components: {BsWithdraw,UnFrozen},
  data() {
    return {
      request: {
        phone: '',
        contactName: '',
        subjectName: '',
        startTime: '',
        endTime: '',
        current: '',
        size: ''
      },
      query: {current: 1, size: 15},
      response: {data: [], total: 0},
      loading: false,
      time: "",
      bsWithdrawDialog: false,
      canUserMoney: '',
      frozenMoney: '',
      reason: '',
      item: '',
      unFrozenDialog: false,
      frozenMoneyDialog: false,
    };
  },
  methods: {

    /**
     * 获取商户列表
     */
    getAllBsFund() {
      this.request.startTime = this.time[0];
      this.request.endTime = this.time[1];
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      bcCapitalDetail(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
     * 页码改变
     */
    currenChangeHandle(value){
      this.query.current = value;
      this.getAllBsFund();
    },

    /**
     * 重置
     */
    reset(){
      this.request.phone = "";
      this.request.contactName = "";
      this.time = "";
      this.query.current = 1;
      this.getAllBsFund();
    },

    /**
     * 商户提现记录
     */
    bsWithdraw(id){
      this.bsWithdrawDialog = true;
      this.$nextTick(()=>{
        this.$refs.bsWithdraw.init(id);
      })
    },

    /**
     * 商户账号操作
     */
    accountOperation(item){
      this.$confirm('确认是否操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        operationAccount({identity: "bs", id: item.id, state: item.state === "0" ? "1" : 0}).then(result=>{
          if(result.code === "000000"){
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          this.loading = false;
          this.getAllBsFund();
          }
        })
      })
    },

    /**
     * 冻结余额弹窗
     */
    showFrozenMoneyDialog(item){
      this.frozenMoneyDialog = true;
      this.canUserMoney = item.withdrawAble;
      this.item = item;
    },

    /**
     * 冻结余额
     */
    frozenMoneyOperation(){
      this.$confirm('确认是否操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(Number(this.frozenMoney <= 0)){
          this.$message({
            type: 'error',
            message: '冻结金额必须大于0!'
          });
          return;
        }
        if(Number(this.canUserMoney) < Number(this.frozenMoney)){
          this.$message({
            type: 'error',
            message: '冻结金额不能超过可提现金额!'
          });
          return;
        }
        frozenBalance({id: this.item.id, money: this.frozenMoney , reason: this.reason}).then(result=>{
          if(result.code === "000000"){
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.frozenMoneyDialog = false;
            this.getAllBsFund();
          }
        })
      })
    },

    /**
     * 关闭弹窗
     */
    closeDialog(){
      this.canUserMoney = '';
      this.frozenMoney = '';
      this.reason = '';
      this.item = ''
    },

    /**
     * 冻结记录
     */
    unFrozen(id){
      this.unFrozenDialog = true;
      this.$nextTick(()=>{
        this.$refs.unFrozen.init(id);
      })
    },

    /**
     * 解冻成功，重新请求
     */
    unFrozenSucceed(){
      this.getAllBsFund();
    },

    /**
     * 导出商户资金明细
     */
    bsCapitalDetailExport(){
       this.$notify({
          message: '正在准备Excel文件，准备完成之后系统会自动下载文件，请稍后',
          type: 'success',
          duration: 3000,
          position: 'bottom-right'
        });
      bsCapitalDetailExport(this.request).then(result=>{
        if(result.code === "000000"){
        window.open(GLOBAL_URL.excelUpload+result.data);
        }
      })
    }
  },
  mounted() {
    this.getAllBsFund();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.bsFundsDetail {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/fundsaccount/bsfundsdetail.vue